import { Serializers } from "@megaron/serializers";
import { UriBuilder, UriOfSchema, UriSchema, UriSpec } from "@megaron/uri";

export const httpUriSchema = UriSchema({
  "http://{hostAndPath}": UriSpec({ hostAndPath: Serializers.string }),
  "https://{hostAndPath}": UriSpec({ hostAndPath: Serializers.string }),
});

export type HttpUriSchema = typeof httpUriSchema;
export const HttpUri = UriBuilder(httpUriSchema);
export type HttpUri = UriOfSchema<HttpUriSchema>;
